export const noItemsFoundTheme = {
  icon: {
    bgCircle: 'palette.tertiary.20',
    cloud: 'palette.primary.70',
    dot: 'palette.primary.20',
    search: 'palette.tertiary.70',
    searchCircle: 'palette.surface.5',
  },
  message: 'palette.tertiary.40',
  title: 'palette.tertiary.90',
};
